<form [formGroup]="cargueForm" class="card tp-card">
  <div class="card-header d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center gap-2">
      <mat-icon class="header-icon">cloud_upload</mat-icon>
      <b class="header-title">Cargue de productos TP</b>
    </div>

    <button type="button" mat-button class="gray no-padding" *ngIf="fileName" (click)="clearFile(inputFile)">
      Limpiar
    </button>
  </div>

  <div class="card-body">
    <mat-form-field appearance="outline" class="w-100 mb-4">
      <mat-label>Política</mat-label>

      <mat-select formControlName="politica">
        <mat-option value="">Seleccionar Política</mat-option>

        <mat-option *ngFor="let item of politicas" [value]="item">
          {{ item.NOMBRE }} - Numeral {{ item.NUMERAL }}
        </mat-option>
      </mat-select>

      <mat-error *ngIf="cargueForm.get('politica')?.invalid">
        Debes seleccionar una política
      </mat-error>
    </mat-form-field>

    <div class="dropzone" [class.dropzone-active]="isDragging" [class.dropzone-filled]="fileName"
      (click)="inputFile.click()" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)">

      <ng-container *ngIf="!fileName">
        <mat-icon class="dropzone-icon">upload_file</mat-icon>
        <p class="dropzone-text">
          Arrastra tu archivo aquí o <span class="dropzone-link">haz clic para seleccionar</span>
        </p>
        <p class="dropzone-hint">Formatos permitidos: .xls, .xlsx</p>
      </ng-container>

      <div class="file-chip" *ngIf="fileName" (click)="$event.stopPropagation()">
        <mat-icon class="file-chip-icon">description</mat-icon>
        <span class="file-chip-name">{{ fileName }}</span>
        <button type="button" class="file-chip-remove" (click)="clearFile(inputFile)" aria-label="Quitar archivo">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <input type="file" accept=".xls,.xlsx" (change)="onSelectFile($event)" #inputFile hidden />

    <button type="button" mat-button class="primary w-100 mt-4 submit-btn"
      [disabled]="!isFileLoaded || cargueForm.invalid" (click)="onSubmit()">
      <mat-icon>publish</mat-icon>
      Subir Archivo
    </button>
  </div>
</form>